import React, { useEffect, useState } from 'react';
import { api } from './supabaseApi';
import { reportTime } from './Reports';
export default function TaskComments({ taskId }) {
  const [comments,setComments] = useState([]), [body,setBody] = useState(''), [error,setError] = useState(''), [busy,setBusy] = useState(false);
  useEffect(() => {
    let active = true;
    if (taskId) api.get(`/comments/${taskId}`).then(rows=>{if(active) setComments(rows);}).catch(e=>{if(active) setError(`Comments unavailable: ${e.message}`);});
    return () => {active=false;};
  },[taskId]);
  if (!taskId) return <div className="ib">Save the task first to post staff comments. Comments are timestamped separately from the task description.</div>;
  async function post() {
    if (!body.trim() || busy) return;
    setBusy(true);setError('');
    try { const row = await api.post(`/comments/${taskId}`,{body:body.trim()}); setComments(previous=>[row,...previous]);setBody(''); }
    catch(e) {setError(e.message);} finally {setBusy(false);}
  }
  return <section className="fg"><h3>Task comments</h3><p>Comments are posted immediately and cannot be edited. Showing the latest 100 comments; full history is available to Admin / Owner in Reports.</p>
    {error && <div className="aerr" role="alert">{error}</div>}
    <textarea aria-label="Task comment" className="fc" maxLength={4000} value={body} onChange={e=>setBody(e.target.value)} placeholder="Add a progress update or comment…" />
    <button type="button" className="btn bp" disabled={busy || !body.trim()} onClick={post}>{busy?'Posting…':'Post comment'}</button>
    {comments.map(c=><div className="ib gr" key={c.id} style={{marginTop:10}}><b>{c.author_name} · {reportTime(c.created_at)} IST</b><p style={{whiteSpace:'pre-wrap',overflowWrap:'anywhere'}}>{c.body}</p></div>)}
  </section>;
}
